// Telemedicine actions
export const SET_TELEMEDICINE_PROVIDER_DETAILS =
  "SET_TELEMEDICINE_PROVIDER_DETAILS";
export const FETCH_TELEMEDICINE_PROVIDER_DETAILS_FAILED =
  "FETCH_TELEMEDICINE_PROVIDER_DETAILS_FAILED";

// // Balance Billing actions
// export const ADD_PROVIDER_BILLS = "ADD_PROVIDER_BILLS";
// export const REMOVE_PROVIDER_BILLS = "REMOVE_PROVIDER_BILLS";
export const PROVIDER_BILLS = "PROVIDER_BILLS";
// Patients Responsibility Billing actions
export const PATIENTS_RESPONSIBILITY_BILLS = "PATIENTS_RESPONSIBILITY_BILLS";

//ExplanationOfBenefits Bills
export const EXPLANATION_OF_BENEFITS_BILLS = "EXPLANATION_OF_BENEFITS_BILLS";

//Collection Notice
export const COLLECTION_NOTICE_BILLS = "COLLECTION_NOTICE_BILLS";

//Subsequect provider bills
export const SUBSEQUENT_PROVIDER_BILLS = "SUBSEQUENT_PROVIDER_BILLS";

export const FETCH_BALANCEBILLING_BENEFICIARY_DETAILS_STARTED =
  "FETCH_BALANCEBILLING_BENEFICIARY_DETAILS_STARTED";
export const FETCH_BALANCEBILLING_BENEFICIARY_DETAILS_SUCCESS =
  "FETCH_BALANCEBILLING_BENEFICIARY_DETAILS_SUCCESS";
export const FETCH_BALANCEBILLING_BENEFICIARY_DETAILS_FAILED =
  "FETCH_BALANCEBILLING_BENEFICIARY_DETAILS_FAILED";

//New Upload actions
export const ADD_NEW_UPLOAD = "ADD_NEW_UPLOAD";

// Submit Bills actions
export const SUBMIT_BALANCEBILLS_FAILED = "SUBMIT_BALANCEBILLS_FAILED";
export const SUBMIT_BALANCEBILLS_SUCCESS = "SUBMIT_BALANCEBILLS_SUCCESS";
export const SUBMIT_BALANCEBILLS_STARTED = "SUBMIT_BALANCEBILLS_STARTED";
export const RESET_SUBMIT_BALANCEBILLS = "RESET_SUBMIT_BALANCEBILLS";

// Find a provider actions
export const SET_PROVIDER_TYPE = "SET_PROVIDER_TYPE";
export const FETCH_PROVIDER_TYPE_FAILED = "FETCH_PROVIDER_TYPE_FAILED";

export const SET_PROVIDER_SEPCIALITY = "SET_PROVIDER_SEPCIALITY";
export const FETCH_PROVIDER_SEPCIALITY_FAILED =
  "FETCH_PROVIDER_SEPCIALITY_FAILED";

// Find a provider results
export const FETCH_PROVIDERS_START = "FETCH_PROVIDERS_START";
export const FETCH_PROVIDERS_FAILED = "FETCH_PROVIDERS_FAILED";
export const FETCH_PROVIDERS_SUCCESS = "FETCH_PROVIDERS_SUCCESS";

// MY FAVORITES results
export const FETCH_MY_FAVORITES_START = "FETCH_MY_FAVORITES";
export const FETCH_MY_FAVORITES_FAILED = "FETCH_MY_FAVORITES_FAILED";
export const FETCH_MY_FAVORITES_SUCCESS = "FETCH_MY_FAVORITES_SUCCESS";

//Fetch Provider Details
export const FETCH_PROVIDER_DETAILS_START = "FETCH_PROVIDER_DETAILS_START";
export const FETCH_PROVIDER_DETAILS_FAILED = "FETCH_PROVIDER_DETAILS_FAILED";
export const FETCH_PROVIDER_DETAILS_SUCCESS = "FETCH_PROVIDER_DETAILS_SUCCESS";

//Submit Feedback
export const SUBMIT_FEEDBACK_STARTED = "SUBMIT_FEEDBACK_STARTED";
export const SUBMIT_FEEDBACK_FAILED = "SUBMIT_FEEDBACK_FAILED";
export const SUBMIT_FEEDBACK_SUCCESS = "SUBMIT_FEEDBACK_SUCCESS";
export const SUBMIT_FEEDBACK_RESET = "SUBMIT_FEEDBACK_RESET";

//Search param
export const ADD_SEARCH_PARAM = "ADD_SEARCH_PARAM";
export const RESET_SEARCH_PARAM = "RESET_SEARCH_PARAM";

//Favorite/Unfavorite provider
export const FAVORITE_PROVIDER_STARTED = "FAVORITE_PROVIDER_STARTED";
export const FAVORITE_PROVIDER_SUCCESS = "FAVORITE_PROVIDER_SUCCESS";
export const FAVORITE_PROVIDER_ERROR = "FAVORITE_PROVIDER_ERROR";
export const UNFAVORITE_PROVIDER_STARTED = "UNFAVORITE_PROVIDER_STARTED";
export const UNFAVORITE_PROVIDER_SUCCESS = "UNFAVORITE_PROVIDER_SUCCESS";
export const UNFAVORITE_PROVIDER_ERROR = "UNFAVORITE_PROVIDER_ERROR";
//this seems to be a hack
export const RESET_UNFAVORITE_PROVIDER_SUCCESS =
  "RESET_UNFAVORITE_PROVIDER_SUCCESS";
export const RESET_FAVORITE_PROVIDER_SUCCESS =
  "RESET_FAVORITE_PROVIDER_SUCCESS";

//Procedure Shopper details
export const SET_PROCEDURE_DETAILS = "SET_PROCEDURE_DETAILS";
export const FETCH_PROCEDURE_DETAILS_FAILED = "FETCH_PROCEDURE_DETAILS_FAILED";

//Procedure Questionnaire
export const FETCH_PROCEDURE_QUESTIONNAIRE_STARTED =
  "FETCH_PROCEDURE_QUESTIONNAIRE_STARTED";
export const FETCH_PROCEDURE_QUESTIONNAIRE_SUCCESS =
  "FETCH_PROCEDURE_QUESTIONNAIRE_SUCCESS";
export const FETCH_PROCEDURE_QUESTIONNAIRE_FAILED =
  "FETCH_PROCEDURE_QUESTIONNAIRE_FAILED";

// Submit Bills actions
export const SUBMIT_PROCEDURE_SHOPPER_FAILED =
  "SUBMIT_PROCEDURE_SHOPPER_FAILED";
export const SUBMIT_PROCEDURE_SHOPPER_SUCCESS =
  "SUBMIT_PROCEDURE_SHOPPER_SUCCESS";
export const SUBMIT_PROCEDURE_SHOPPER_STARTED =
  "SUBMIT_PROCEDURE_SHOPPER_STARTED";

//current Location
export const FETCH_CURRENT_LOCATION_FAILED = "FETCH_CURRENT_LOCATION_FAILED";
export const FETCH_CURRENT_LOCATION_SUCCESS = "FETCH_CURRENT_LOCATION_SUCCESS";
export const FETCH_CURRENT_LOCATION_STARTED = "FETCH_CURRENT_LOCATION_STARTED";
export const RESET_CURRENT_LOCATION = "RESET_CURRENT_LOCATION";

//app config
export const FETCH_APP_CONFIG_FAILED = "FETCH_APP_CONFIG_FAILED";
export const FETCH_APP_CONFIG_SUCCESS = "FETCH_APP_CONFIG_SUCCESS";
export const FETCH_APP_CONFIG_STARTED = "FETCH_APP_CONFIG_STARTED";

//Parse Access Token
//app config
export const PARSE_ACCESS_TOKEN_FAILED = "PARSE_ACCESS_TOKEN_FAILED";
export const PARSE_ACCESS_TOKEN_SUCCESS = "PARSE_ACCESS_TOKEN_SUCCESS";
export const PARSE_ACCESS_TOKEN_STARTED = "PARSE_ACCESS_TOKEN_STARTED";

//dispute Authorization
export const DISPUTE_AUTHORIZATION_FILE = "DISPUTE_AUTHORIZATION_FILE";
export const RESET_DISPUTE_AUTHORIZATION_FILE =
  "RESET_DISPUTE_AUTHORIZATION_FILE";
export const FETCH_BEST_CONTACT_INFO = "FETCH_BEST_CONTACT_INFO";
export const UDPATE_BEST_CONTACT_INFO = "UDPATE_BEST_CONTACT_INFO";
export const RESET_FETCH_BEST_CONTACT_INFO = "RESET_FETCH_BEST_CONTACT_INFO";

//Contact Information
export const SUBMIT_CONTACT_INFORMATION_FAILED =
  "SUBMIT_CONTACT_INFORMATION_FAILED";
export const SUBMIT_CONTACT_INFORMATION_SUCCESS =
  "SUBMIT_CONTACT_INFORMATION_SUCCESS";
export const SUBMIT_CONTACT_INFORMATION_STARTED =
  "SUBMIT_CONTACT_INFORMATION_STARTED";
export const RESET_SUBMIT_CONTACT_INFORMATION =
  "RESET_SUBMIT_CONTACT_INFORMATION";

//Claim Details
export const FETCH_BALANCE_BILLING_CLAIM_DETAILS_STARTED =
  "FETCH_BALANCE_BILLING_CLAIM_DETAILS_STARTED";
export const FETCH_BALANCE_BILLING_CLAIM_DETAILS_SUCCESS =
  "FETCH_BALANCE_BILLING_CLAIM_DETAILS_SUCCESS";
export const FETCH_BALANCE_BILLING_CLAIM_DETAILS_FAILED =
  "FETCH_BALANCE_BILLING_CLAIM_DETAILS_FAILED";
export const RESET_BALANCE_BILLING_CLAIM_DETAILS =
  "RESET_BALANCE_BILLING_CLAIM_DETAILS";

//Submit claim
export const SUBMIT_BALANCE_BILLING_CLAIM_STARTED =
  "SUBMIT_BALANCE_BILLING_CLAIM_STARTED";
export const SUBMIT_BALANCE_BILLING_CLAIM_SUCCESS =
  "SUBMIT_BALANCE_BILLING_CLAIM_SUCCESS";
export const SUBMIT_BALANCE_BILLING_CLAIM_FAILED =
  "SUBMIT_BALANCE_BILLING_CLAIM_FAILED";
export const RESET_SUBMIT_BALANCE_BILLING_CLAIM =
  "RESET_SUBMIT_BALANCE_BILLING_CLAIM";

//fetch document types
export const FETCH_DOCUMENT_TYPES_STARTED = "FETCH_DOCUMENT_TYPES_STARTED";
export const FETCH_DOCUMENT_TYPES_SUCCESS = "FETCH_DOCUMENT_TYPES_SUCCESS";
export const FETCH_DOCUMENT_TYPES_FAILED = "FETCH_DOCUMENT_TYPES_FAILED";
export const RESET_DOCUMENT_TYPES = "RESET_DOCUMENT_TYPES";

//fetch userInfo
export const FETCH_USER_INFO_STARTED = "FETCH_USER_INFO_STARTED";
export const FETCH_USER_INFO_SUCCESS = "FETCH_USER_INFO_SUCCESS";
export const FETCH_USER_INFO_FAILED = "FETCH_USER_INFO_FAILED";

//fetch status
export const FETCH_BALANCE_BILLING_STATUS_STARTED =
  "FETCH_BALANCE_BILLING_STATUS_STARTED";
export const FETCH_BALANCE_BILLING_STATUS_SUCCESS =
  "FETCH_BALANCE_BILLING_STATUS_SUCCESS";
export const FETCH_BALANCE_BILLING_STATUS_FAILED =
  "FETCH_BALANCE_BILLING_STATUS_FAILED";

//fetch balance billing history
export const FETCH_BALANCE_BILLING_HISTORY_FOR_USER_STARTED =
  "FETCH_BALANCE_BILLING_HISTORY_FOR_USER_STARTED";
export const FETCH_BALANCE_BILLING_HISTORY_FOR_USER_SUCCESS =
  "FETCH_BALANCE_BILLING_HISTORY_FOR_USER_SUCCESS";
export const FETCH_BALANCE_BILLING_HISTORY_FOR_USER_FAILED =
  "FETCH_BALANCE_BILLING_HISTORY_FOR_USER_FAILED";

//fetch status
export const FETCH_BALANCE_BILLING_CLAIM_STATUS_STARTED =
  "FETCH_BALANCE_BILLING_CLAIM_STATUS_STARTED";
export const FETCH_BALANCE_BILLING_CLAIM_STATUS_SUCCESS =
  "FETCH_BALANCE_BILLING_CLAIM_STATUS_SUCCESS";
export const FETCH_BALANCE_BILLING_CLAIM_STATUS_FAILED =
  "FETCH_BALANCE_BILLING_CLAIM_STATUS_FAILED";

//fetch myPlans Documents
export const FETCH_MYPLANS_DOCUMENTS_STARTED =
  "FETCH_MYPLANS_DOCUMENTS_STARTED";
export const FETCH_MYPLANS_DOCUMENTS_SUCCESS =
  "FETCH_MYPLANS_DOCUMENTS_SUCCESS";
export const FETCH_MYPLANS_DOCUMENTS_SUCCESS_NO_LIST =
  "FETCH_MYPLANS_DOCUMENTS_SUCCESS_NO_LIST";
export const FETCH_MYPLANS_DOCUMENTS_FAILED = "FETCH_MYPLANS_DOCUMENTS_FAILED";
export const RESET_MYPLANS_DOCUMENTS_STARTED =
  "RESET_MYPLANS_DOCUMENTS_STARTED";

//fetch quality score categories list
export const FETCH_QUALITY_SCORE_CATEGORIES_STARTED =
  "FETCH_QUALITY_SCORE_CATEGORIES_STARTED";
export const FETCH_QUALITY_SCORE_CATEGORIES_SUCCESS =
  "FETCH_QUALITY_SCORE_CATEGORIES_SUCCESS";
export const FETCH_QUALITY_SCORE_CATEGORIES_FAILED =
  "FETCH_QUALITY_SCORE_CATEGORIES_FAILED";
export const RESET_FETCH_QUALITY_SCORE_CATEGORIES =
  "RESET_FETCH_QUALITY_SCORE_CATEGORIES";

//fetch quality score category Id
export const FETCH_QUALITY_SCORE_CATEGORY_ID_STARTED =
  "FETCH_QUALITY_SCORE_CATEGORY_ID_STARTED";
export const FETCH_QUALITY_SCORE_CATEGORY_ID_SUCCESS =
  "FETCH_QUALITY_SCORE_CATEGORY_ID_SUCCESS";
export const FETCH_QUALITY_SCORE_CATEGORY_ID_FAILED =
  "FETCH_QUALITY_SCORE_CATEGORY_ID_FAILED";
export const RESET_FETCH_QUALITY_SCORE_CATEGORY_ID =
  "RESET_FETCH_QUALITY_SCORE_CATEGORY_ID";

//fetch All claims
export const FETCH_ALL_CLAIMS_STARTED = "FETCH_ALL_CLAIMS_STARTED";
export const FETCH_ALL_CLAIMS_SUCCESS = "FETCH_ALL_CLAIMS_SUCCESS";
export const FETCH_ALL_CLAIMS_FAILED = "FETCH_ALL_CLAIMS_FAILED";
export const RESET_FETCH_ALL_CLAIMS = "RESET_FETCH_ALL_CLAIMS";

//set correct balance bill view
export const SET_BALANCE_BILL_VIEW_STATE = "SET_BALANCE_BILL_VIEW_STATE";
export const RESET_BALANCE_BILL_VIEW_STATE = "RESET_BALANCE_BILL_VIEW_STATE";

export const SET_MY_BILL_VIEW_STATE = "SET_MY_BILL_VIEW_STATE";
export const RESET_MY_BILL_VIEW_STATE = "RESET_MY_BILL_VIEW_STATE";

export const GET_ONE_TIME_SIGNATURE_ADDRESSES_STARTED =
  "GET_ONE_TIME_SIGNATURE_ADDRESSES_STARTED";
export const GET_ONE_TIME_SIGNATURE_ADDRESSES_SUCCESS =
  "GET_ONE_TIME_SIGNATURE_ADDRESSES_SUCCESS";
export const GET_ONE_TIME_SIGNATURE_ADDRESSES_FAILED =
  "GET_ONE_TIME_SIGNATURE_ADDRESSES_FAILED";

export const POST_DAF_STARTED = "POST_DAF_STARTED";
export const POST_DAF_SUCCESS = "POST_DAF_SUCCESS";
export const POST_DAF_FAILED = "POST_DAF_FAILED";

//submit updated address
export const SUBMIT_UPDATED_ADDRESS_STARTED = "SUBMIT_UPDATED_ADDRESS_STARTED";
export const SUBMIT_UPDATED_ADDRESS_SUCCESS = "SUBMIT_UPDATED_ADDRESS_SUCCESS";
export const SUBMIT_UPDATED_ADDRESS_FAILED = "SUBMIT_UPDATED_ADDRESS_FAILED";
export const RESET_UPDATED_ADDRESS = "RESET_UPDATED_ADDRESS";

//creating the updated address
export const ADD_UPDATED_ADDRESS_PARAM = "ADD_UPDATED_ADDRESS_PARAM";
export const RESET_UPDATED_ADDRESS_PARAM = "RESET_UPDATED_ADDRESS_PARAM";
export const SHOULD_UPLOAD_DOCUMENT = "SHOULD_UPLOAD_DOCUMENT";

//fetch group pecific contracts

export const FETCH_GROUP_SPECIFIC_CONTRACTS_STARTED =
  "FETCH_GROUP_SPECIFIC_CONTRACTS_STARTED";
export const FETCH_GROUP_SPECIFIC_CONTRACTS_FAILED =
  "FETCH_GROUP_SPECIFIC_CONTRACTS_FAILED";
export const FETCH_GROUP_SPECIFIC_CONTRACTS_SUCCESS =
  "FETCH_GROUP_SPECIFIC_CONTRACTS_SUCCESS";
//get drexi seeion id
export const GET_DREXI_SESSION_ID_STARTED =
  "GET_DREXI_SESSION_ID_STARTED";
export const GET_DREXI_SESSION_ID_SUCCESS =
  "GET_DREXI_SESSION_ID_SUCCESS";
export const GET_DREXI_SESSION_ID_FAILED =
  "GET_DREXI_SESSION_ID_FAILED";
//fetch access token
export const FETCH_ACCESS_TOKEN_STARTED = "FETCH_ACCESS_TOKEN_STARTED";
export const FETCH_ACCESS_TOKEN_FAILED = "FETCH_ACCESS_TOKEN_FAILED";
export const FETCH_ACCESS_TOKEN_SUCCESS = "FETCH_ACCESS_TOKEN_SUCCESS";


//fetch can user impersonate
export const CAN_USER_IMPERSONATE_STARTED = "FETCH_ACCESS_TOKEN_STARTED";
export const CAN_USER_IMPERSONATE_FAILED = "CAN_USER_IMPERSONATE_FAILED";
export const CAN_USER_IMPERSONATE_SUCCESS = "CAN_USER_IMPERSONATE_SUCCESS";


//fetch can user impersonate
export const IMPERSONATED_USER_TOKEN_SUCCESS = "IMPERSONATED_USER_TOKEN_SUCCESS";
export const IMPERSONATED_USER_TOKEN_FAILED = "IMPERSONATED_USER_TOKEN_FAILED";
export const IMPERSONATED_USER_TOKEN_STARTED = "IMPERSONATED_USER_TOKEN_STARTED";

